<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div class="driver-view">
  <div>
    <div class="heading">
      <h3>Edit Credit Trip</h3>
    </div>
    <mat-divider></mat-divider>
    <form class="admin-forms truckComponent mt-3">
      <div class="input-fileds-container category-edit">
        <form [formGroup]="editCreditForm">
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Vehicle Number</mat-label>
                    <input matInput formControlName="truck_number" readonly />
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Driver Name</mat-label>
                    <input matInput formControlName="username" readonly />
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Mobile Number</mat-label>
                    <input matInput formControlName="mobile" readonly />
                  </mat-form-field>
                </div>
              </div>

              <div class="row mtb">
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Net Quantity(Loading Point)</mat-label>
                    <input matInput formControlName="loading_point" readonly />
                    <mat-error>Please enter loading point</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Net Quantity(Unloading Point)</mat-label>
                    <input
                      matInput
                      formControlName="unloading_point"
                      required
                    />
                    <mat-error>Please enter unloading point</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Price Per Ton</mat-label>
                    <input matInput formControlName="price_per_ton" readonly />
                    <mat-error>Please enter price per ton</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row mtb">
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Sales Order Number</mat-label>
                    <input
                      matInput
                      formControlName="sales_order_number"
                      placeholder="Enter Sales order Number"
                      required
                      appAlphanumericOnly
                      toUppercase
                      maxlength="16"
                    />
                    <mat-error>Please enter sales order number</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>LR No</mat-label>
                    <input
                      matInput
                      formControlName="lr_number"
                      placeholder="Enter LR Number"
                      required
                      appAlphanumericOnly
                      toUppercase
                      maxlength="16"
                    />
                    <mat-error>Please enter lr number</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>LR Date</mat-label>
                    <mat-datepicker #picker></mat-datepicker>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      placeholder="RC Valid"
                      [max]="maxDate"
                      formControlName="lr_date"
                      required
                      (click)="picker.open()"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error>Select LR Date</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row mtb">
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>Tax Invoice no</mat-label>
                    <input
                      matInput
                      formControlName="tax_invoice_no"
                      placeholder="Enter Tax Invoice Number"
                      required
                      toUppercase
                      maxlength="16"
                      (keypress)="validateTaxInvoiceInput($event)"
                    />
                    <mat-error>Please enter tax invoice number</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field>
                    <mat-label>DDC No</mat-label>
                    <input
                      matInput
                      formControlName="ddc_no"
                      placeholder="Enter DDC Number"
                      required
                      appAlphanumericOnly
                      toUppercase
                      maxlength="16"
                    />
                    <mat-error>Please enter ddc number</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              type="button"
              [class.spinner]="loading"
              [disabled]="loading"
              class="button buttonBlue mt-3"
              (click)="updateTrip()"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</div>
